var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9023 19.25V6.40234H5.84766V19.25H15.9023ZM15.9023 4.59766C16.3893 4.59766 16.819 4.78385 17.1914 5.15625C17.5638 5.5 17.75 5.91536 17.75 6.40234V19.25C17.75 19.737 17.5638 20.1667 17.1914 20.5391C16.819 20.9115 16.3893 21.0977 15.9023 21.0977H5.84766C5.36068 21.0977 4.93099 20.9115 4.55859 20.5391C4.1862 20.1667 4 19.737 4 19.25V6.40234C4 5.91536 4.1862 5.5 4.55859 5.15625C4.93099 4.78385 5.36068 4.59766 5.84766 4.59766H15.9023ZM13.1523 0.902344V2.75H2.15234V15.5977H0.347656V2.75C0.347656 2.26302 0.519531 1.83333 0.863281 1.46094C1.23568 1.08854 1.66536 0.902344 2.15234 0.902344H13.1523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0f06fe6bf6df9620db11555c3d548972.svg";
export { ForwardRef as ReactComponent };